<header class="border-bottom">
    <div class="row w-100 mx-0 align-items-center gx-lg-5">
        <a routerLink="/" class="col-auto navbar-brand shadow-sm cursor-pointer">
            <img class="mx-auto" src="../../../assets/images/logo.png" alt="BKJ" />
        </a>
        <div class="col">
            <div class="row justify-content-end">
                <!-- Company Name -->
                <div class="col">
                    <div class="page-header d-flex align-items-center justify-content-between mb-3" *ngIf="!isOrderWorkflowPage()">
                        <div class="d-flex align-items-center">
                            <h5 class="mb-0 text-dark">{{componentName}}</h5>
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-auto" *ngIf="isOrderWorkflowPage()">
                            <!-- Nav tabs for all order types -->
                            <ul class="nav nav-tabs mt-1">
                                <li class="nav-item">
                                    <a class="nav-link" [class.active]="activeTab === 'primary'"
                                        (click)="setActiveTab('primary')">
                                        {{ getOrderTypeLabel() }}
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link" [class.active]="activeTab === 'scheme'"
                                        (click)="setActiveTab('scheme')">Scheme</a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link" [class.active]="activeTab === 'preview'"
                                        (click)="setActiveTab('preview')">Preview
                                        Order</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <!-- Right Section -->
                <div class="col-auto d-flex align-items-center gap-3">

                    <!-- Location Autocomplete -->
                    <div class="location-box position-relative rounded-5 p-2 d-none">
                        <div class="input-group">
                            <span class="input-group-text text-white border-0 bg-transparent">
                                <i class="fas fa-map-marker-alt"></i>
                            </span>
                            <input type="text" class="form-control bg-transparent border-0 rounded-0 p-0"
                                placeholder="Search" [(ngModel)]="selectedLocation" (input)="onLocationInput()"
                                (focus)="showSuggestions = true" />
                        </div>
                        <ul *ngIf="showSuggestions && filteredLocations.length" class="autocomplete-list">
                            <li *ngFor="let loc of filteredLocations" (click)="selectLocation(loc)">
                                {{ loc }}
                            </li>
                        </ul>
                    </div>

                    <!-- User Info with Dropdown -->
                    <div ngbDropdown class="dropdown">
                        <a class="d-flex align-items-center text-decoration-none" ngbDropdownToggle id="userDropdown"
                            role="button">

                            <span class="me-2 fw-medium text-body">{{ userName }}</span>
                            <!-- Avatar with first letter/number -->
                            <div class="avatar-circle">
                                {{ userName?.charAt(0)?.toUpperCase() }}
                            </div>
                        </a>

                        <ul ngbDropdownMenu aria-labelledby="userDropdown" class="dropdown-menu dropdown-menu-end">
                            <li>
                                <button class="dropdown-item" (click)="logout()">Logout</button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</header>